import {
  DeliveryForecastDespatchAdviceItem,
  DeliveryForecastItem,
  DeliveryForecastItemSplit,
  DespatchAdviceItem,
  InvoiceItem,
  OrderResponseItem,
} from '../../data/models'

// isItemInitial
export function isItemInitial(
  items:
    | (
        | OrderResponseItem
        | DespatchAdviceItem
        | InvoiceItem
        | DeliveryForecastItem
        | DeliveryForecastDespatchAdviceItem
      )[]
    | undefined,
): boolean {
  // loop over all items and check if one item is NOT_SET
  const isInitial = items?.find(item => {
    // For OrderResponseItem, DespatchAdviceItem and InvoiceItem
    if ('ConfirmationCode' in item) {
      return item.ConfirmationCode === 'NOT_SET'
      // For DeliveryForecastItem
    } else if ('Splits' in item) {
      return item.Splits.find(splitItem => {
        return splitItem.Status === 'NOT_SET'
      })
    }
    return false
  })

  return isInitial ? true : false
}

// isItemModified
export interface ComparisonItem {
  order: any
  confirmation: any
}

export function isItemModified(comparisonItem: ComparisonItem): boolean {
  return (comparisonItem.order ?? '') !== (comparisonItem.confirmation ?? '')
}

// areItemsModified
export interface ComparisonArray extends Array<ComparisonItem> {}

export function areItemsModified(comparisonArray: ComparisonArray): boolean {
  const isModified = comparisonArray.find(comparisonItem =>
    isItemModified(comparisonItem),
  )

  return isModified ? true : false
}

// isOrderModified
export function isOrderModified(
  items: (
    | OrderResponseItem
    | DespatchAdviceItem
    | InvoiceItem
    | DeliveryForecastDespatchAdviceItem
  )[],
): boolean {
  // loop over all items and check if a item was touched (modified or rejected)
  const isModified = items?.find(
    (
      item:
        | OrderResponseItem
        | DespatchAdviceItem
        | InvoiceItem
        | DeliveryForecastDespatchAdviceItem,
    ) =>
      item.ConfirmationCode === 'MODIFIED' ||
      item.ConfirmationCode === 'REJECTED',
  )

  return isModified ? true : false
}

export function isButtonDisabled(
  action: 'accept' | 'modify', // if the button is for accepting the item use "accept" for other action as change delivery date use "modify"
  items?:
    | (OrderResponseItem | DespatchAdviceItem | InvoiceItem)[]
    | DeliveryForecastItemSplit[]
    | null,
): boolean {
  if (!items?.length) {
    return true // if no items are selected disable the button
  }

  const isModifiedOrRejected = items?.some(item => {
    // For Order, Delivery, Invoice
    if ('ConfirmationCode' in item) {
      if (action === 'accept') {
        return (
          item.ConfirmationCode === 'MODIFIED' ||
          item.ConfirmationCode === 'REJECTED'
        )
      } else {
        return item.ConfirmationCode === 'REJECTED'
      }
      // For Delivery Forecast
    } else if ('Status' in item) {
      if (action === 'accept') {
        return item.Status === 'MODIFIED' || item.Status === 'REJECTED'
      } else {
        return item.Status === 'REJECTED'
      }
    }
  })

  return isModifiedOrRejected
}
